import { BrowserRouter } from 'react-router-dom';
import './App.css';
import AppRoutes from './Components/Router/Router';
import { LoadingProvider } from './context/LoadingContext';

function App() {
  return (
    <BrowserRouter>
    <LoadingProvider>
        <AppRoutes />
  </LoadingProvider>
    </BrowserRouter>
  );
}

export default App;
